import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetNewsListParams = Required<operations['NewsController_findAll']['parameters']>['query']
type GetNewsCategoryListParams = Required<operations['NewsController_findAllCategory']['parameters']>['query']

/**
 * 뉴스 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param categoryId 뉴스 카테고리 id
 * @param sort 뉴스 정렬 기준
 * @returns ResListNotice
 */
export const getNewsList = async ({ size = 50, offset = 0, categoryId, sort }: GetNewsListParams) => {
  return (
    await axios.get<components['schemas']['ResListNews']>('/news', { params: { size, offset, categoryId, sort } })
  ).data
}

/**
 * 뉴스 카테고리 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @returns ResListDisclosureCategory
 */
export const getNewsCategories = async ({ size = 50, offset = 0 }: GetNewsCategoryListParams) => {
  return (
    await axios.get<components['schemas']['ResListDisclosureCategory']>('/news/category', {
      params: { size, offset },
    })
  ).data
}

export type { GetNewsListParams }
